import { jwtDecode } from 'jwt-decode';
import { z } from 'zod';

import type { AuthorizationTokenResponsePayload } from './authorization-token';
import { authorizationTokenDecodedTransformedSchema } from './authorization-token';

const tokenResponseSchema = z.object({
    expires_in: z.number(),
    id_token: z.string(),
    refresh_token: z.string().optional(),
});

export const sessionResponseSchema = tokenResponseSchema
    .extend({
        id_token: z.string().transform((jsonWebToken) => {
            const attributes = authorizationTokenDecodedTransformedSchema.parse(
                jwtDecode<AuthorizationTokenResponsePayload>(jsonWebToken),
            );

            return {
                attributes,
                jsonWebToken,
            };
        }),
    })
    .transform(({ expires_in, id_token, refresh_token }) => ({
        attributes: id_token.attributes,
        expiresInSeconds: expires_in,
        jsonWebToken: id_token.jsonWebToken,
        refreshJsonWebToken: refresh_token,
    }));

export type SessionResponse = z.infer<typeof sessionResponseSchema>;

export const sessionTransferResponseSchema = z.object({
    encrypted: z.string(),
});
